module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hant/5-f4c8e764dc41b2863a0eaec7012e9b9c.jpg";